/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Partner = {
  type: 'BaseResponseCompany',
} as const;
